import {DistributionPropertyG} from './classes/distribution-property-g';
import {DistributionPropertyPercentage} from './classes/distribution-property-percentage';
import {IMacronutrientDistributionValues} from './interfaces/macronutrient-distribution-values.interface';
import {MacronutrientDistribution} from './macronutrient-distribution';

export class MxStrategy extends MacronutrientDistribution {
  constructor() {
    super();
    this.carbohydrates = new DistributionPropertyPercentage('H. de carbono', { minimum: 30, maximum: 35 }, 30, 'icons8-trigo-50.png');
    this.lipids = new DistributionPropertyPercentage('Grasas', { minimum: 30 }, 30, 'icons8-sashimi-50.png');
    this.protein = new DistributionPropertyPercentage('Proteínas', { minimum: 45 }, 40, 'icons8-filete-50.png');
    this.fiber = new DistributionPropertyG('Fibra', 12.5, 0, 'icons8-hoja-50.png');
  }

  init(value: IMacronutrientDistributionValues): void {
    // suma de gramos
    const total = value.carbohydrate_g + value.dietaryFiber_g + value.totalFat_g + value.protein_g;
    this.carbohydrates.setValue(
      value.carbohydrate_g > 0 ?
        Math.round(((value.carbohydrate_g * 100) / total)) :
        30
    );
    this.lipids.setValue(
      value.totalFat_g > 0 ?
        Math.round(((value.totalFat_g * 100) / total)) :
        30
    );
    this.protein.setValue(
      value.protein_g > 0 ?
        Math.round(((value.protein_g * 100) / total)) :
        40
    );
    this.fiber.setValue(
      value.dietaryFiber_g > 0 ?
        Math.round(((value.dietaryFiber_g * 100) / total)) :
        0
    );
  }
}
